import type {
    BusinessProductPriceTier,
    Pagination,
} from '@barboxx/models/types';

import { api } from '../../api';

const rootPath = 'businesses/product-price-tiers';

export function getProductPriceTiers(
    query: BusinessProductPriceTier.SearchQuery
) {
    return api.get<Pagination<BusinessProductPriceTier>>(rootPath, query);
}

export function getProductAvailability(
    query: BusinessProductPriceTier.AvailabilitySearchQuery
) {
    return api.get<BusinessProductPriceTier.AvailabilitySearchResponse>(
        `${rootPath}/availability`,
        query
    );
}

export function getProductPriceTier(id: number) {
    return api.get<BusinessProductPriceTier.DetailsResponse>(
        `${rootPath}/${id}`,
        undefined
    );
}

export function postProductPriceTier(
    data: BusinessProductPriceTier.CreateRequest
) {
    return api.post<BusinessProductPriceTier>(rootPath, data);
}

export function putProductPriceTier(
    id: number,
    data: BusinessProductPriceTier.UpdateRequest
) {
    return api.put<BusinessProductPriceTier>(`${rootPath}/${id}`, data);
}

export function putProductAvailability(
    data: BusinessProductPriceTier.SetProductAvailabilityRequest
) {
    return api.put<BusinessProductPriceTier.SetProductAvailabilityResponse>(
        `${rootPath}/availability`,
        data
    );
}

export function deleteProductPriceTier({
    id,
}: BusinessProductPriceTier.DeleteRequest) {
    return api.delete(`${rootPath}/${id}`, undefined);
}
